import http from '@/utils/http';

module.exports = {
  // 目录列表
  apiGetTabList() {
    return http
      .get('/workscene/workscene/v1/knowledge/toC/category/queryList')
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 问题列表
  apiGetQuestionList(data) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .post(
        '/workscene/workscene/v1/knowledge/toC/question/queryList',
        JSON.stringify(data),
        headers
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  //问题详情
  apiGetQuestionDetail(questionId) {
    return http
      .get(
        '/workscene/workscene/v1/knowledge/toC/question/queryQuestionDetail',
      {
        questionId,
      }
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 是否解决
  apiSolveQuestion(params) {
    return http
      .get(
        '/workscene/workscene/v1/knowledge/toC/question/solveQuestion',
        params
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 热门搜索
  apiGetHotSearch() {
    return http
      .get('/workscene/workscene/v1/knowledge/toC/question/queryHotSearch')
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 搜索历史
  // /workscene/v1/knowledge/toC/question/queryPersonSearch
  apiGetHistory() {
    return http
      .get('/workscene/workscene/v1/knowledge/toC/question/queryPersonSearch')
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 清空搜索历史
  apiClearHistory() {
    return http
      .get('/workscene/workscene/v1/knowledge/toC/question/clearPersonSearch')
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 点击热搜
  apiVlickHotSearch(params) {
    return http
      .get(
        '/workscene/workscene/v1/knowledge/toC/question/clickHotSearch',
        params
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 推荐列表

  apiGeRecommendList(data) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .post(
        '/workscene/workscene/v1/knowledge/toC/question/queryRecommendList',
        JSON.stringify(data),
        headers
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

};
